import { render, staticRenderFns } from "./SideNavItem.vue?vue&type=template&id=7572aca1&scoped=true&"
import script from "./SideNavItem.vue?vue&type=script&lang=js&"
export * from "./SideNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SideNavItem.vue?vue&type=style&index=0&id=7572aca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572aca1",
  null
  
)

export default component.exports